import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { IPickerOption } from '../Picker/types';
import TabPickerTab from './components/TabPickerTab/TabPickerTab';
import './style.scss';

export interface ITabPickerProps {
  options: IPickerOption[];
  value: IPickerOption['value'];
  onChange: (value: IPickerOption['value']) => void;
  noLabelTranslate?: boolean;
  disabled?: boolean;
  error?: boolean;
  className?: string;
  tabClassName?: string;
}

const TabPicker: FC<ITabPickerProps> = (props: ITabPickerProps): JSX.Element => {
  const wrapperClassName = useMemo((): string => {
    return classNames('tab-picker', props.className, { 'input-error': props.error });
  }, [props.className, props.error]);

  return (
    <div className={wrapperClassName}>
      {props.options.map((tab) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <TabPickerTab key={tab.value} tab={tab} {...props} />
      ))}
    </div>
  );
};

export default TabPicker;
